import * as Yup from "yup";

/**
 * Overrides Yup's email validation to use a slightly stricter one
 *
 * The regex is based on RFC2822 (https://regexr.com/2rhq7)
 * with the addition of a 2-63 character range on the domain
 * - based on RFC1034 used in django
 * https://docs.djangoproject.com/en/3.0/_modules/django/core/validators/
 */
Yup.addMethod(
  Yup.string,
  "email",
  function (failedMessage = "Please enter a valid email") {
    return this.test({
      name: "email",
      exclusive: true,
      message: failedMessage,
      test: (value) => {
        if (!value) return true; // Use required to check this
        const emailRegex = RegExp(
          /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@((?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?){2,63}\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
          "i"
        );
        return emailRegex.test(value);
      },
    });
  }
);
